<template>
  <div>
    <!-- <b-row class="component-margin-half" v-if="memberId !== ''">
      <b-col md="5">
        <inbound-confirmation-filter
          :nameFilter="nameFilter" @changeProductFilter="changeName($event)"
          :sizeFilter="sizeFilter" @changeSizeFilter="changeSize($event)"
          :inboundFilter="inboundFilter" @changeInboundFilter="changeInboundFilter($event)"
          />
      </b-col>
    </b-row> -->
    <b-row class="component-margin-half" v-if="account !== ''">
      <b-col md="12">
        <inbound-confirmation-table
          :items="items"
          @downloadFile="downloadFile($event)"
          @uploadCsvFile="uploadCsvFile($event)"
          @uploadPdfFile="uploadPdfFile($event)"
          />
      </b-col>
    </b-row>
    <b-row>
      <b-modal ref="messagePopup" ok-only hide-header>
        <div class="text-center">{{confirmMessage}}</div>
      </b-modal>
    </b-row>
  </div>
</template>

<script>
import Vue from 'vue';
import ReasonType from '@/types/ReasonType';
import BaseComponent from '@/components/BaseComponent';
// import InboundConfirmationFilter from '@/components/inbound-confirmation/InboundConfirmationFilter';
import InboundConfirmationTable from '@/components/inbound-confirmation/InboundConfirmationTable';
import * as api from '@/api';

export default {
  mixins: [BaseComponent],
  data() {
    return {
      items: [],
      nameFilter: '',
      sizeFilter: '8',
      inboundFilter: '0',
      account: '',
      confirmMessage: '',
    }
  },
  created() {
    this.account = this.$store.state.account;
    api.getInoutSummaryList(this.account, (data) => {
      this.items = data.inoutSummaries;
      this.addCellVariant(this.items);
    });
  },
  methods: {
    uploadCsvFile($event) {
      const formData = new FormData();
      formData.append('file', $event[0]);
      formData.append('keyCode', $event[1]);
      api.uploadInoutSummaryCsv(formData, (data) => {
        this.items = data.inoutSummaries;
        this.confirmMessage = 'CSVをアップロードしました。';
        this.$refs.messagePopup.show();
        this.addCellVariant(this.items);
      });
    },
    uploadPdfFile($event) {
      const formData = new FormData();
      formData.append('file', $event[0]);
      formData.append('keyCode', $event[1]);
      api.uploadInoutSummaryPdf(formData, (data) => {
        this.items = data.inoutSummaries;
        this.confirmMessage = 'PDFをアップロードしました。';
        this.$refs.messagePopup.show();
        this.addCellVariant(this.items);
      });
    },
    downloadFile($event) {
      let anchor = document.createElement('a');
      anchor.href = $event;
      anchor.target = '_blank';
      anchor.click();
    },
    addCellVariant(items) {
      this.hasErrors = false;
      for (const v of items) {
        const errorCells = [];
        if (v['status'] === 'uninput') {
          errorCells['refMonth'] = 'danger';
          errorCells['category'] = 'danger';
          errorCells['name'] = 'danger';
          errorCells['totalAmount'] = 'danger';
          errorCells['totalBilledAmountThisMonth'] = 'danger';
          errorCells['totalCarryOverAmount'] = 'danger';
          errorCells['inputDataCsv'] = 'danger';
          errorCells['inputDataPdf'] = 'danger';
          errorCells['viewDetail'] = 'danger';
          errorCells['statusJp'] = 'danger';
        } else if (v['status'] === 'uncomplete') {
          errorCells['refMonth'] = 'warning';
          errorCells['category'] = 'warning';
          errorCells['name'] = 'warning';
          errorCells['totalAmount'] = 'warning';
          errorCells['totalBilledAmountThisMonth'] = 'warning';
          errorCells['totalCarryOverAmount'] = 'warning';
          errorCells['inputDataCsv'] = 'warning';
          errorCells['inputDataPdf'] = 'warning';
          errorCells['viewDetail'] = 'warning';
          errorCells['statusJp'] = 'warning';
        }
        v['_cellVariants'] = errorCells;
      }
    },
  },
};

// Vue.component('inbound-confirmation-filter', InboundConfirmationFilter);
Vue.component('inbound-confirmation-table', InboundConfirmationTable);
</script>

<style>
.small-image {
  max-width: 75%; /* 画像の最大幅を設定 */
  height: auto; /* 高さを自動調整 */
  cursor: pointer; /* マウスを乗せたときにポインターを指し示す */
}
.banner-margin {
  margin-top: -0.5rem;
  margin-bottom: 0.5rem;
}
.component-margin {
  margin-bottom: 1rem;
}
th.table-base {
  background-color: aliceblue!important;
}

th.table-ans {
  background-color: beige!important;
}

.component-margin-half {
  margin-bottom: .5rem;
}
.image {
  align-content: center;
  height: 4rem;
  width: 4rem; 
}
td.table-success{
  background-color: rgba(40,167,69,.25);
}
td.table-warning{
  background-color: #ffeeba59;
}
table label{
  margin-bottom: 0;
}
table .image{
  height: 3rem;
  width: 3rem;
}
.text-window {
    padding: 1em;
    background-color: lightblue;
}
</style>
